<template>
  <div>
    <div v-if="mode == 1">
      <div class="grid">
        <div class="head_text">項目名</div>
        <!-- <div class="head_text">kg</div> -->
        <div class="head_text">廃棄量</div>
      </div>

      <div
        class="grid"
        style="margin-top: 5px"
        :key="index"
        v-for="(item, index) in listData"
      >
        <div
          class="center_aligned_container item_name_text ellipsis_text item_padding"
        >
          {{ item.label }}
        </div>
        <!-- <div class="center_aligned_container item_value_text item_padding">{{ item.itemWeight }}</div> -->
        <div style="display: inline-flex">
          <div
            class="bar"
            :style="{
              width: item.percentage + '%',
              'background-color': getBarColor(index),
            }"
          ></div>
          <div class="item_value_text center_aligned_container">
            {{ item.itemCo2Weight + "kg" }}
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        style="margin-top: 5px"
        :key="item.label"
        v-for="(item, index) in listData"
      >
        <div style="display: inline-flex">
          <div
            class="item_name_text ellipsis_text item_padding"
            style="font-weight: 600"
          >
            {{ item.label }}
          </div>
          <!-- <div class="item_value_text item_padding" v-if="item.itemWeight.length > 0" style="align-self: center;">{{ item.itemWeight + 'kg' }}</div> -->
        </div>
        <div style="display: inline-flex; width: 100%; height: 20px">
          <div
            class="bar"
            :style="{
              width: item.percentage + '%',
              'background-color':
                barColorMap != null
                  ? barColorMap.get(item.label)
                  : getBarColor(index),
            }"
          ></div>
          <div class="item_value_text center_aligned_container">
            {{ item.itemCo2Weight + "kg" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../mixins/utils'

export default {
  name: 'PartsResultHorizontalBarChart',
  components: { },
  props: {
    receivedData: {
      type: Object,
      default: () => {}
    },
    itemWeightInGram: {
      type: Object,
      default: () => {}
    },
    barColorMap: {
      type: Map,
      default: null
    },
    barColors: {
      type: Array,
      default: () => ['#8A3FFC', '#A56EFF', '#BE95FF', '#D4BBFF', '#E8DAFF']
    },
    mode: {
      type: Number,
      default: 0
    }
  },
  mixins : [utils],
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      // 重さの順に並び替える
      var pairs = Object.entries(this.receivedData);
      pairs.sort(function(p1, p2){
        var p1Val = p1[1], p2Val = p2[1];
        return p2Val - p1Val;
      })
      const map = new Map(pairs)
      var sortedReceivedData = Object.fromEntries(pairs);

      const itemWeight = this.itemWeightInGram != null ? new Map(Object.entries(this.itemWeightInGram)) : new Map()
      if(map.size == 0) {
        return
      }
      this.listData = []

      let maxValue = Number(Object.values(sortedReceivedData)[0]) / 1000 // 一番大きい
      map.forEach((val, key) => {
        let datalabel = String(key)
        let data = Number(val) / 1000
        let percentage = data / maxValue * 100

        let weightInGram = itemWeight.get(key)
        let weight = weightInGram != null ?  this.convertToFormattedNumber(Number(weightInGram) / 1000) : ''

        this.listData.push(
          {
            label: datalabel,
            itemWeight: weight,
            itemCo2Weight: this.convertToFormattedNumber(data, 3),
            percentage: percentage
          }
        )
      });
    },
    getBarColor(position) {
      return position < 5 ? this.barColors[position] : this.barColors.at(-1)
    }
  },
  watch: {
    receivedData: function() {
      this.fetchData()
    }
  },
  data() {
    return {
      dialog: false,
      listData: [],
    }
  }
}

</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: 3fr 20fr;
}

.head_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.17px;
  color: #343a3f;
}

.item_name_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-transform: capitalize;
  color: #343a3f;
}

.item_value_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 1px;
  color: #343a3f;
}

.item_padding {
  padding-right: 5px;
}

.bar {
  border-radius: 4px;
  margin-right: 5px;
  margin-top: 3px;
  margin-bottom: 3px;
}

.center_aligned_container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.ellipsis_text {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  word-wrap: brek-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: start;
}

.items-leave-active,
.items-enter-active {
  transition: opacity 1s, transform 1s ease;
}
.items-leave-to,
.items-enter {
  opacity: 0;
  transform: translateX(50px);
}
.items-leave,
.items-enter-to {
  opacity: 1;
}
.items-move {
  transition: transform 1s;
}
</style>
